import type { OverviewSubject } from 'src/clients/hooks/useOverview';
import { getSharedFamily, type ParticipantFamily } from 'src/meetings/utils/event-utils';

export type MeetingOverview = {
  key: string;
  subject: OverviewSubject;
  name: string;
};

type Attendee = {
  id: string;
  name: string;
};

// One family overview when every client attendee belongs to the same family
// (the family route always resolves to its own family); otherwise one individual
// overview per attendee, so unrelated clients are never grouped under a family.
export function resolveMeetingOverviews(
  attendees: Attendee[],
  familiesByClientId: Map<string, ParticipantFamily>,
  routeFamily: ParticipantFamily | null,
): MeetingOverview[] {
  const sharedFamily =
    routeFamily ??
    getSharedFamily(
      attendees.map(attendee => attendee.id),
      familiesByClientId,
    );
  if (sharedFamily) {
    return [
      {
        key: sharedFamily.id,
        subject: { kind: 'family', familyId: sharedFamily.id },
        name: sharedFamily.name,
      },
    ];
  }
  return attendees.map(attendee => ({
    key: attendee.id,
    subject: { kind: 'client', clientId: attendee.id },
    name: attendee.name,
  }));
}
